<template>
  <div class="my-courses">
    <div v-if="loading"
         class="my-courses__loading-container">
      <div class="my-courses__loading-content">
        <h6>Loading courses</h6>
        <font-awesome-icon icon="spinner"
                           class="icon"
                           size="lg"
                           spin></font-awesome-icon>
      </div>
    </div>
    <template v-else>
      <CoursesTable
        heading="Courses: in-progress"
        button-text="Access course"
        :fields="fields"
        :courses="inProgressCourses">
      </CoursesTable>
      <CoursesTable
        heading="Courses: completed"
        button-text="Retake course"
        :fields="fields"
        :courses="completedCourses">
      </CoursesTable>
    </template>
  </div>
</template>

<script>
import { listCourses } from "~/Scripts/resources/coursesResource";
import CoursesTable from "~/Components/Accounts/Courses/CoursesTable.vue";

export default {
  name: "MyCourses",

  components: { CoursesTable },

  props: {
    webAccountId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      courses: [],
      fields: [
        {
          key: "courseName",
          label: "Course name",
          class: "my-courses__col-name",
          tdClass: "my-courses__col-name"
        },
        {
          key: "courseProductCode",
          label: "Product code",
          class: "my-courses__col-code",
          tdClass: "my-courses__col-code"
        },
        {
          key: "actions",
          label: "",
          class: "my-courses__col-actions",
          tdClass: "my-courses__col-actions"
        }
      ]
    };
  },
  computed: {
    inProgressCourses () {
      return this.courses.filter( c => c.percentComplete < 1 );
    },
    completedCourses () {
      return this.courses.filter( c => c.percentComplete >= 1 );
    }
  },
  created () {
    this.loading = true;

    listCourses( this.webAccountId, "ACT" )
      .then( result => {
        if ( result && result.data && result.data.length > 0 ) {
          result.data.forEach( c => {
            this.courses = this.courses.concat( c.lmsCourses );
          } );
        }
      } )
      .catch( error => {
        console.log( "error listing wishlists", error );
        throw error;
      } )
      .finally( () => {
        this.loading = false;
      } );
  }
};
</script>

<style lang="less" scoped>
@import "../../../Styles/utils/index";

/deep/ .my-courses {
  &__container {
    padding-bottom: 20px;
  }

  &__loading-container {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    position: absolute;
    z-index: 100;
    pointer-events: none;
    background-color: rgba(255, 255, 255, 0.7);
  }

  &__loading-content {
    display: flex;
    align-items: center;
    h6 {
      margin-bottom: 0;
    }

    .icon {
      margin-left: 10px;
    }
  }

  &__heading {
    letter-spacing: normal;
    font-weight: bold;
    font-size: 16pt;
    margin-top: 0;
    margin-bottom: 30px;
  }

  &__items-table {
    background-color: #fff;
  }

  &__items-container {
    max-height: 100%;
    overflow-x: auto;
    position: relative;
  }

  &__col-name {
    width: 50%;
  }

  &__actions-container {
    float: right;
    display: flex;
    flex-wrap: wrap;

    button {
      .babcock-table-action();
    }
  }

  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
}
</style>
